import { roles } from 'const/roles';

export const isDistributor = () => {
  const userRoles = JSON.parse(localStorage.getItem('userData')).roles;
  return userRoles.some(role => role === roles.distributor);
};
